module.exports = __webpack_public_path__ + "static/media/ngo-logo.fbb1ae58.svg";